import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { SubmitEnrollmentDataResponse } from '../../models/submit-enrollment-data-response'
import { PortalGlobals } from '../../../portalglobals'
import { EnrollmentCacheData } from '../../models/EnrollmentCacheData'
import { GetEnrollmentDataResponse, GetEnrollmentDataByID } from '../../models/get-enrollment-data-response'

@Component({
    selector: 'ExternalAgentCheckList',
    templateUrl: 'external-agent-check-list.html'
})
export class ExternalAgentCheckList implements OnInit {
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    confirmationNumber: string
    hasError: boolean
    ErrorMessages: any[]
    AccountName: string
    AccountType: string
    AgentName: string
    DataEntryAgentName: string
    userPofilename: string
    agentID: string
    appDate: string
    effDate: string
    dob: string
    orgName: string
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()
    insuranceCompany: string

    public loading: boolean = false
    constructor(private router: Router, private _enrollementGateway: EnrollmentGateway, public _global: PortalGlobals) {
        this.enrollment = {} as EnrollmentViewModel
        this.ErrorMessages = [] as any[]
    }

    ngOnInit() {
        this.hasError = false
        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        this.orgName = this._global.currentUser.insuranceCompanyName
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()

        if (this.enrollment.AGENTID === null || this.enrollment.AGENTID === undefined || this.enrollment.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)

                //this.getEnrollmentDataResponse = this._enrollementGateway.getEnrollmentDataByKey(this.EnrollmentKey)

                this.loading = true
                this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                    (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                        this.enrollment = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                        this.enrollment.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                        this.enrollment.ADMINID = this.enrollmentCacheData.AdminID
                        this.enrollment.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                        this.enrollment.AGENTNAME = this.enrollmentCacheData.AgentName
                        this.enrollment.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                        this.enrollment.USERNAME = this.enrollmentCacheData.USERNAME
                        this.enrollment.ACCESSKEY = this.enrollmentCacheData.ACCESSKEY
                        this.enrollment.ENROLLMENTID = this.enrollmentCacheData.ENROLLMENTID
                        this._global.selectedPlanYear = this.enrollmentCacheData.PlanYear
                        this.enrollment.FORMNAME = this.enrollmentCacheData.FORMNAME

                        this.LoadData()
                        this.loading = false
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                this.Back()
            }
        } else {
            this.LoadData()
        }
        this.setOrgname()
    }

    LoadData(): void {
        if (this.enrollment !== undefined && this.enrollment.CONF !== undefined) {
            this.confirmationNumber = this.enrollment.CONF
        }
    }

    Confirm() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.updateDataServiceCall('/' + insCo + '/enrollment/external-agent/Step5')
    }

    Back() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/external-agent/Step4'])
    }

    updateDataServiceCall(route: string) {
        this.loading = true
        this.enrollment.SUBMISSIONTYPECODE = 'COMPLETE'
        this.enrollment.STEPCODE = '4'
        this._enrollementGateway.UpdateEnrollmentData(this.enrollment).subscribe(
            (model: SubmitEnrollmentDataResponse) => {
                let response = model
                if (response !== undefined) {
                    if (response.Errors !== undefined && response.Errors.length > 0) {
                        this.hasError = false

                        for (let i = 0; i < response.Errors.length; i++) {
                            this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                        }
                        window.scrollTo(0, 0)
                    } else {
                        if (response.confirmationNumber !== undefined && response.confirmationNumber !== null && response.confirmationNumber !== '') {
                            this.enrollment.CONF = response.confirmationNumber
                            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                            this.loading = false
                            this.router.navigate([route])
                        } else {
                            this.ErrorMessages.push('Error while submitting data, please try again.')
                            window.scrollTo(0, 0)
                        }
                    }
                } else {
                    this.ErrorMessages.push('Error while submitting data, please try again.')
                    window.scrollTo(0, 0)
                }
                this.loading = false
            },
            (err) => {
                this.loading = false
            }
        )
    }

    private setOrgname() {
        if (this._global.selectedPlanYear === 0 || this._global.selectedPlanYear === undefined) {
            if (sessionStorage.getItem('PLANYEAR') !== undefined) {
                this._global.selectedPlanYear = Number(sessionStorage.getItem('PLANYEAR'))
            }
        }
        if (Number(this._global.selectedPlanYear) === this._global.CurrentYear) {
            this.insuranceCompany = this.orgName
        } else {
            this.insuranceCompany = this._global.insCompanyNameAetna
        }
    }
}
